<template>
	<nav class="navbar navbar-expand-lg navbar-dark bg-light nav-fill" :class="{'navbarOpen': show}">
		<div class="container">
		<router-link class="navbar-brand" to="/shop">
			<img class="brand-image" src='../../../assets/image/logo-test.png' width="150" height="150" alt="">
		</router-link>
		<button class="navbar-toggler"
				type="button"
				data-toggle="collapse"
				data-target="#navbarSupportedContent"
				aria-controls="navbarSupportedContent"
				aria-expanded="false"
				aria-label="Toggle navigation"
				@click.stop="toggleNavigation"
		>
			<span class="navbar-toggler-icon"/>
		</button>

		<div class="collapse navbar-collapse" id="navbarSupportedContent" :class="{ 'show': show }">
			<ul class="navbar-nav">
                <li class="nav-item active">
                    <router-link class="nav-link" to="/">Početna</router-link>
                </li>
                <b-nav-item-dropdown text="Prodavnica" right class="active" >
                    <router-link style="color: #1A1A1A !important;" class="dropdown-item" to="/shop/face">Nega Lica</router-link>
                    <router-link style="color: #1A1A1A !important;" class="dropdown-item" to="/shop/body">Nega Tela</router-link>
                    <router-link style="color: #1A1A1A !important;" class="dropdown-item" to="/shop/candle">Sveće</router-link>
<!--                    <router-link style="color: #1A1A1A !important;" class="dropdown-item" to="/shop/sample">Uzorci</router-link>-->
                </b-nav-item-dropdown>
                <li class="nav-item active">
                    <router-link class="nav-link" to="/cart">Korpa</router-link>
                </li>
                <li class="	nav-item active">
                    <router-link class="nav-link" to="/">O nama</router-link>
                </li>
                <li class="nav-item active" >
                    <router-link class="nav-link" to="/">Kontakt</router-link>
                </li>

				<!--                    <b-nav-item-dropdown-->
				<!--                        text="Prodavnica"-->
				<!--                        right-->
				<!--                        :class="{active: $route.name === 'shop' || $route.name === 'item'}"-->
				<!--                    >-->
				<!--                        <router-link class="dropdown-item" to="/shop/face" :class="{active: this.$route.params.category === 'face'}">Nega Lica</router-link>-->
				<!--                        <router-link class="dropdown-item" to="/shop/body" :class="{active: this.$route.params.category === 'body'}">Nega Tela</router-link>-->
				<!--    	                    <router-link class="dropdown-item" to="/shop/giftbox" :class="{active: this.$route.params.category === 'giftbox'}">Poklon Kutije</router-link>-->
				<!--                    </b-nav-item-dropdown>-->

			</ul>
		</div>
		</div>
	</nav>
</template>

<script>
	import {mapMutations} from "vuex";

	export default {
		name: 'HomeNavigation',
		data() {
			return {
				show: false
			}
		},
		methods: {
			...mapMutations([
                'setNavToggled'
            ]),

            toggleNavigation() {
				this.show = !this.show
                this.setNavToggled(this.show)
            }
		}
	}
</script>

<style scoped>
	.navbar {
		position: absolute;
		width: 100%;
		margin: 0;
		padding: 0;
		background: transparent !important;
		z-index: 10;
	}

    .navbar-nav {
        width: 100%;
        display: flex;
        justify-content: right;
    }

	.navbar-nav:last-child {
		margin-left: auto;
	}

	.nav-item {
		font-size: 18px;
	}

	.nav-link {
		color: #F0EAD6;
	}

	.brand-image {
		border-radius: 50%;
	}

    .dropdown-item {
        /*background-color: #F0EAD6 !important;*/
        padding-top: 10px;
        padding-bottom: 10px;
    }

	.dropdown-item.active,
	.dropdown-item:active {
		color: rgba(0, 0, 0, 0.9);
		text-decoration: none;
		background-color: transparent !important;
	}

	.dropdown-item:focus,
	.dropdown-item:hover {
		color: rgba(0, 0, 0, 0.9);
		text-decoration: none;
		background-color: transparent !important;
	}
</style>
